import React from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaGlobe } from 'react-icons/fa';
import { HiOutlineLocationMarker, HiOutlineMail, HiOutlinePhone } from 'react-icons/hi';

const Footer = () => {
  return (
    // bg-gradient-to-r from-[#696dd8] via-[#0f9ce3] to-[#08bb6a]
    <footer className="bg-[#202779] py-8">
      <div className="container mx-auto px-8 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          
          {/* Logo and Social Media Icons */}
          <div className="flex flex-col items-center md:items-start">
            <img src="./assets/imgs/logo2.png" alt="UDC Logo" className="w-60 mt-2 mb-5 " />
            <div className="flex space-x-4">
              {/* Social Media Icons */}
              <a href="#" className="bg-white text-[#202779] p-2 rounded-full">
                <FaGlobe />
              </a>
              <a href="#" className="bg-white text-[#202779] p-2 rounded-full">
                <FaInstagram />
              </a>
              <a href="#" className="bg-white text-[#202779] p-2 rounded-full">
                <FaFacebookF />
              </a>
              <a href="#" className="bg-white text-[#202779] p-2 rounded-full">
                <FaTwitter />
              </a>
            </div>
          </div>

          {/* Location */}
          <div className="text-center md:text-left">
            <h4 className="text-white font-semibold mb-4">Location</h4>
            <p className="text-white">
              <HiOutlineLocationMarker className="inline-block mr-2" />
              23-24 Opal St, Severina Diamond Km. 18, 
               West Service Road Parañaque City 1700, 
               Metro Manila, Philippines
            </p>
          </div>

          {/* Contact Info */}
          <div className="text-center md:text-left">
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <p className="text-white">
              <HiOutlineMail className="inline-block mr-2" />
              sales@udesiccants.com.ph
            </p>
            <p className="text-white">
              <HiOutlinePhone className="inline-block mr-2" />
              (6328) 821-0117, 821-0118, 
              <br />
              776-8474, 776-5466
            </p>
            <p className="text-white">
              <HiOutlinePhone className="inline-block mr-2" />
              Fax: (6328) 824-0257, 776-5266
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 text-center text-white">
          © {new Date().getFullYear()} Universal Desiccants Corporation | All Rights Reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;
